import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { useMantineTheme, Box, Group, Text, Button, Card, ActionIcon, TextInput, Loader } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { BE_API_ONE, utils } from "../../utils/globalVariables";
import { numberWithComma, getValuePropInObj, regexStringAlphaNumOnlyUpperCase } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import DiscountVoucherSelectorModal from "../utilities/DiscountVoucherSelectorModal";

const DiskonBlock = ({ stateData, fnOnChange, fnOnChangeVoucherCode }) => {

  const mountedRef = React.useRef(true);
  const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorSubmitData: 'DiskonBlock-1',
  })

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const [data, setData] = React.useState({
    show: false,

    voucherCode: '',
    voucherCodeError: '',
    voucherCodeSubmitLoading: false,

    submitLoading: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  })

  const fnSubmit = (obj) => {
    setData(d => ({ ...d, submitLoading: true, voucherCodeError: '' }))

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', stateData.projectId);
    formDT.append('project_process', stateData.projectProcess);
    formDT.append('project_is_cancel', stateData.projectIsCancel);

    formDT.append('diskon_id', obj.diskonId);
    formDT.append('diskon_flag', obj.diskonFlag);
    formDT.append('diskon_name', obj.diskonName);
    formDT.append('diskon_type', obj.diskonType);
    formDT.append('diskon_value', obj.diskonValue);
    formDT.append('diskon_deducted_from', obj.diskonDeductedFrom);
    formDT.append('delete_voucher_code', obj.deleteVoucherCode);
    formDT.append('voucher_code_default', stateData.diskonVoucherCode);
    formDT.append('diskon_id_default', stateData.diskonId);

    axios({
      method: 'post',
      url: BE_API_ONE + '/edit_project_diskon_block',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, submitLoading: false, show: false }));

      if (response.data.flag_status === 'isset') {
        fnOnChange({
          diskonId: response.data.diskon_id,
          diskonFlag: response.data.diskon_flag,
          diskonName: response.data.diskon_name,
          diskonType: response.data.diskon_type,
          diskonValue: response.data.diskon_value,
          diskonDeductedFrom: response.data.diskon_deducted_from,
          voucherCode: response.data.voucher_code
        });
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorSubmitData,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, submitLoading: false, show: false }))

      notifications.show({
        id: notificationId.current.errorSubmitData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  const fnSubmitVoucherCode = () => {
    setData(d => ({ ...d, voucherCodeError: '' }));

    if (validator.isEmpty(String(data.voucherCode), { ignore_whitespace: true })) {
      setData(d => ({ ...d, voucherCodeError: 'Kolom wajib diisi.' }));
    } else {
      setData(d => ({ ...d, voucherCodeSubmitLoading: true }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('project_id', stateData.projectId);
      formDT.append('project_process', stateData.projectProcess);
      formDT.append('project_is_cancel', stateData.projectIsCancel);

      formDT.append('diskon_id', stateData.diskonId);
      formDT.append('voucher_code', data.voucherCode);

      axios({
        method: 'post',
        url: BE_API_ONE + '/edit_project_diskon_block_voucher_code',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, voucherCodeSubmitLoading: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({ ...d, voucherCode: '' }));

          fnOnChangeVoucherCode({
            diskonVoucherCode: response.data.voucher_code,
          });
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorSubmitData,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'voucher-code-invalid') {
          setData(d => ({
            ...d,
            voucherCodeError: 'Voucher code is invalid.'
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, voucherCodeSubmitLoading: false }))

        notifications.show({
          id: notificationId.current.errorSubmitData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  return (
    <React.Fragment>
      <Group position='apart'>
        <Text size='sm' fw='500'>
          Diskon Voucher
        </Text>

        <Button
          size='xs'
          variant='light'
          compact={true}

          onClick={() => setData(d => ({ ...d, show: true }))}
        >
          Pilih Diskon/Voucher
        </Button>
      </Group>

      {stateData.diskonId ?
        <Card
          mt='1rem'
          shadow=''
          radius="sm"
          withBorder={true}

          sx={(tema) => ({
            backgroundColor: stateData.diskonFlag === utils.discountFlag.discount.value ? tema.colors.blue[0] : tema.colors.orange[0],
          })}
        >
          <Card.Section p='sm'>
            <Box>
              <Group
                pb='.5rem'
                position='apart'
                align="center"
                sx={(tema) => ({
                  color: stateData.diskonFlag === utils.discountFlag.discount.value ? tema.colors.blue[9] : tema.colors.orange[9],
                  borderBottom: `1px dashed ${stateData.diskonFlag === utils.discountFlag.discount.value ? tema.colors.blue[9] : tema.colors.orange[9]}`
                })}
              >
                <Text
                  size="sm"
                  fw={500}
                >
                  {getValuePropInObj(utils.discountFlag, 'value', stateData.diskonFlag, 'label', ' - ').toUpperCase()}
                </Text>

                <ActionIcon
                  size="1.35rem"
                  radius="xl"
                  variant='filled'
                  color={stateData.diskonFlag === utils.discountFlag.discount.value ? 'blue' : 'orange'}

                  onClick={() => {
                    fnSubmit({
                      diskonId: '',
                      diskonFlag: '',
                      diskonName: '',
                      diskonType: '',
                      diskonValue: '',
                      diskonDeductedFrom: '',
                      deleteVoucherCode: '1'
                    })
                  }}
                >
                  <IconTrash
                    size=".85rem"
                  />
                </ActionIcon>
              </Group>

              <Box
                sx={(tema) => ({
                  color: stateData.diskonFlag === utils.discountFlag.discount.value ? tema.colors.blue[6] : tema.colors.orange[6],
                })}
              >
                <Text
                  size="sm"
                  fw={500}
                  mt='.5rem'
                >
                  {stateData.diskonName}
                </Text>

                <Text size="sm">
                  Potongan {stateData.diskonType === utils.discountType.rupiah.value ? `Rp ${numberWithComma(Number(stateData.diskonValue))}` : `${Number(stateData.diskonValue)}%`} - {getValuePropInObj(utils.discountDeductedFrom, 'value', stateData.diskonDeductedFrom, 'label', ' - ')}
                </Text>
              </Box>
            </Box>
          </Card.Section>
        </Card>
        :
        <Text size="sm" pt='md' color="dimmed">
          Belum ada diskon yang dipilih
        </Text>
      }

      {data.submitLoading &&
        <Group
          mt='.5rem'
          align="center"
          spacing={6}
        >
          <Loader size='xs' />

          <Text
            size='sm'

            sx={(tema) => ({
              color: tema.colors.blue[6],
            })}
          >
            Submitting Discount/Voucher...
          </Text>
        </Group>
      }

      {(stateData.diskonFlag === utils.discountFlag.voucher.value) && !stateData.diskonVoucherCode &&
        <Box mt='1rem'>
          <Text
            size='sm'
            mb='.5rem'

            sx={(tema) => ({
              color: stateData.diskonFlag === utils.discountFlag.discount.value ? tema.colors.red[8] : tema.colors.red[4],
            })}
          >
            Anda belum mendapat potongan harga. Masukkan kode voucher untuk mendapatkan diskon ini.
          </Text>

          <Group noWrap spacing='xs' align="center">
            <TextInput
              placeholder='Kode Voucher'
              styles={() => ({
                root: { width: '100%' },
                input: { backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7] }
              })}
              value={data.voucherCode}
              onChange={(e) => setData(d => ({ ...d, voucherCode: regexStringAlphaNumOnlyUpperCase(e.target.value) }))}
            />

            <Button
              size="xs"
              onClick={fnSubmitVoucherCode}
              loading={data.voucherCodeSubmitLoading}
            >
              Submit
            </Button>
          </Group>
        </Box>
      }

      {(stateData.diskonFlag === utils.discountFlag.voucher.value) && stateData.diskonVoucherCode &&
        <>
          <Text
            size='sm'
            mt='.5rem'
            align="center"
          >
            Voucher Code: {stateData.diskonVoucherCode}
          </Text>

          <Text
            size='sm'
            align="center"
          >
            Anda berhasil mendapat potongan harga.
          </Text>
        </>
      }

      {data.voucherCodeError &&
        <Text
          size='sm'
          sx={(tema) => ({
            color: stateData.diskonFlag === utils.discountFlag.discount.value ? tema.colors.red[8] : tema.colors.red[4],
          })}
        >
          {data.voucherCodeError}
        </Text>
      }

      <DiscountVoucherSelectorModal
        stateData={stateData.dataDiscountVoucher}
        stateShow={data.show}

        fnShow={() => setData(d => ({ ...d, show: false }))}

        fnOnSelect={(obj) => fnSubmit({
          diskonId: obj.id,
          diskonFlag: obj.flag,
          diskonName: obj.name,
          diskonType: obj.type,
          diskonValue: obj.value,
          diskonDeductedFrom: obj.deductedFrom,
          deleteVoucherCode: '0'
        })}
      />

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />
    </React.Fragment>
  )
}

export default DiskonBlock;